import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "./Logo";

export default function Footer({ onOpenCookies }) {
  const { t } = useTranslation();
  const { lang } = useParams();
  const currentLang = lang === "en" ? "en" : "it";

  return (
    <footer className="ec-footer">
      <div className="ec-footer-inner">
        <div className="ec-footer-brand">
          <Logo />
          <p className="ec-footer-tag">{t("footer.tagline")}</p>
        </div>

        <div className="ec-footer-col">
          <h4>{t("footer.nav_title")}</h4>
          <ul>
            <li><Link to={`/${currentLang}`}>{t("nav.home")}</Link></li>
            <li><a href={`/${currentLang}#benefits`}>{t("nav.benefits")}</a></li>
            <li><a href={`/${currentLang}#how`}>{t("nav.how")}</a></li>
            <li><a href={`/${currentLang}#projects`}>{t("nav.projects")}</a></li>
            <li><a href={`/${currentLang}#contact`}>{t("nav.contact")}</a></li>
          </ul>
        </div>

        <div className="ec-footer-col">
          <h4>{t("footer.legal_title")}</h4>
          <ul>
            <li><Link to={`/${currentLang}/privacy`}>{t("nav.privacy")}</Link></li>
            <li><Link to={`/${currentLang}/cookies`}>{t("nav.cookies")}</Link></li>
            <li><Link to={`/${currentLang}/terms`}>{t("nav.terms")}</Link></li>
            <li>
              <button className="ec-linklike" onClick={onOpenCookies}>
                {t("footer.manage_cookies")}
              </button>
            </li>
          </ul>
        </div>

        <div className="ec-footer-col ec-footer-legal">
          <h4>{t("footer.contact_title")}</h4>
          <p>
            <strong>{t("footer.address_label")}</strong><br />
            {t("footer.address")}
          </p>
          <p>
            <strong>{t("footer.email_label")}</strong><br />
            <a href={`mailto:${t("footer.email")}`}>{t("footer.email")}</a>
          </p>
        </div>
      </div>

      <div className="ec-footer-legal-band">
        <div className="ec-footer-legal-grid">
          <div><span>{t("footer.reg_label")}</span><strong>{t("footer.reg")}</strong></div>
          <div><span>{t("footer.vat_label")}</span><strong>{t("footer.vat")}</strong></div>
          <div><span>{t("footer.jurisdiction_label")}</span><strong>{t("footer.jurisdiction")}</strong></div>
          <div><span>{t("footer.founded_label")}</span><strong>{t("footer.founded")}</strong></div>
        </div>
        <p className="ec-footer-license"><strong>{t("footer.license_label")}:</strong> {t("footer.license")}</p>
        <p className="ec-footer-disclaimer">{t("footer.disclaimer")}</p>
        <p className="ec-footer-rights">© 2024–2026 Ecominiere — {t("footer.rights")}</p>
      </div>
    </footer>
  );
}
